import DocumentsSchemasRequest from "../ws/schemes/DocumentsSchemasRequest";
import DocumentSchemaType from "../../shared/model/DocumentSchemaType";

export const WORKER_DOCUMENT_SCHEMA_TYPE = 'worker-document-schema-type';
export const WORK_DOCUMENT_SCHEMA_TYPE = 'work-document-schema-type';
export const WORK_DOCUMENT_SCHEMA_LINK_TYPE = 'work-document-schema-link-type';
export const OUTSOURCE_DOCUMENT_SCHEMA_TYPE = 'outsource-document-schema-type';
export const OUTSOURCE_DOCUMENT_SCHEMA_MONTHLY_TYPE = 'outsource-document-schema-monthly-type';

export const getWorkerDocumentSchemaState = () => (dispatch) => {

  new DocumentsSchemasRequest(DocumentSchemaType.WORKER)
    .onSuccess(data => {
      dispatch({
        type: WORKER_DOCUMENT_SCHEMA_TYPE,
        payload: data.data,
      });
    })
    .execute();
};

export const getWorkDocumentSchemaState = () => (dispatch) => {

  new DocumentsSchemasRequest(DocumentSchemaType.WORK)
    .onSuccess(data => {
      dispatch({
        type: WORK_DOCUMENT_SCHEMA_TYPE,
        payload: data.data,
      });
    })
    .execute();
};

export const getWorkDocumentLinkSchemaState = () => (dispatch) => {

  new DocumentsSchemasRequest(DocumentSchemaType.LINKED)
    .onSuccess(data => {
      dispatch({
        type: WORK_DOCUMENT_SCHEMA_LINK_TYPE,
        payload: data.data,
      });
    })
    .execute();
};

export const getOutsourceDocumentSchemaState = () => (dispatch) => {

  new DocumentsSchemasRequest(DocumentSchemaType.OUTSOURCE)
    .onSuccess(data => {
      dispatch({
        type: OUTSOURCE_DOCUMENT_SCHEMA_TYPE,
        payload: data.data,
      });
    })
    .execute();
};
export const getOutsourceDocumentSchemaMontlyState = () => (dispatch) => {

  new DocumentsSchemasRequest(DocumentSchemaType.MONTHLY)
    .onSuccess(data => {
      dispatch({
        type: OUTSOURCE_DOCUMENT_SCHEMA_MONTHLY_TYPE,
        payload: data.data,
      });
    })
    .execute();
};



// WEBPACK FOOTER //
// ./src/app/documents/actions/schemaTypeActions.js